import api from './api';

export const emailTemplateService = {
  getAll: (params = {}) => api.get('/email-templates/', { params }),
  getById: (id) => api.get(`/email-templates/${id}`),
  create: (data) => api.post('/email-templates/', data),
  update: (id, data) => api.put(`/email-templates/${id}`, data),
  delete: (id) => api.delete(`/email-templates/${id}`),
  preview: (id, variables) => api.post(`/email-templates/${id}/preview`, { template_id: id, variables }),
  getCategories: () => api.get('/email-templates/categories/list'),
};
